<template>
  <div class="mk__editor" v-loading = "loading" :class = "{ 'edit__full__screen': isFullScreen }">
     <Toolbar v-if="engine" :engine="engine" :items="items" ></Toolbar>
      <div class="editor-wrapper" :class = "{ 'edit__full__screen__c': isFullScreen }" >
        <div class="editor-container">
          <div class="editor-content">
            <div ref="edit_container"></div>
          </div>
        </div>
      </div>
      <div class="saveBtn" v-if="editStatus">
          <MkBtn type = "2" :width = "96" @click="$emit('cancel')" text='取消' />
          <MkBtn type = "1" :width = "96" @click="editSave" text='保存' />
      </div>
  </div>
</template>

<script> 
  import Engine, {
    $,
  } from "@aomao/engine";
  import Toolbar from 'am-editor-toolbar-vue2';
  import { plugins, cards, pluginConfig, itemConfig } from "./config/config.js";
  import Upload from "./tools/upload.ts"
  export default {
    props:{
      editStatus:{
        type:Boolean,
        default:false,
      },
    },
    data() {
      return {
        engine: null,
        view: null,
        isFullScreen: false,
        items:[],
        editorValue: "",
        htmlValue: "",
        loading: false,
      }
    },
    mounted() {
      this.items = itemConfig;
      this.editorInit();
    },
    beforeDestroy() {
      this.engine.destroy(); // 销毁编辑器
    },
    components: { Toolbar },
    methods: {
      /** 获取报告内容 */
      getValue(){
        return {
          value: this.editorValue,
          html: this.htmlValue,
        }
      },
      /** 保存报告 */
      editSave(){
        let valueObj = this.getValue()
        this.$emit('saveText',valueObj)
      },
      //** 设置报告内容 */
      set_engineValue(e){
         if(!this.engine) return
          // this.engine.setValue(e, () => {
          //   // 渲染完成
          // });
         this.engine.setValue(this.filterText(e), () => {
            // 渲染完成
          });
          console.log( this.engine)
      },
      /** 处理特殊字符 */
      filterText(e){
        let arrEntitles = {
          'lt':'<',
          'gt':">",
          'nbsp':' ',
          'amp':'&',
          'quot':'"'
        }
        return e.replace(/&(lt|gt|nsbp|amp|quot);/ig,(all,t)=>{
            return arrEntitles[t]
        })
      },
      fullClick() {
        this.isFullScreen = !this.isFullScreen;
      },
      // 初始化编辑器
      editorInit() {
        const container = this.$refs.edit_container;
        if(container) {
          const engine = new Engine(container,{
            plugins: plugins,
            cards: cards,
            config: {
              ...pluginConfig,
              FsBtn: {
                fullClick: this.fullClick
              }
            },
          });
          /* 设置引擎监听 */
           // 监听卡片最大
           engine.on("card:maximize", () => {
            $(".editor-toolbar").css("z-index", "9995").css("top", "55px").css("position","fixed").css("left","0").css("height","45px");
          });
           // 监听卡片最小
          engine.on("card:minimize", () => {
            $(".editor-toolbar").css("z-index", "").css("top", "").css("position","relative").css("left","0").css("height","35px");
          });
          // 监听编辑器改变
          engine.on("change", () => {
            const editorValue = engine.getValue();
            const htmlValue = engine.getHtml();
            this.editorValue = editorValue;
            this.htmlValue = htmlValue;
            //console.log("value", value);
            //console.log("html:", engine.getHtml());
          });
          /* 设置回调消息 */
          engine.messageSuccess = this.messageSuccess;
          engine.messageError = this.messageError;
          engine.messageConfirm = this.messageConfirm;


          const value = "欢迎使用芒果编辑器1.0.0！"
          engine.setValue(value, () => {
            // 渲染完成
          });
          this.engine = engine;
          const g_upload = new Upload();
          g_upload.setGlobalUpload(engine);
        }
      },
      // 显示成功消息的回调
      messageSuccess(type,msg,...args) {
        console.log(type,msg,...args);
        this.$message.success(msg);
      },
       // 显示失败消息的回调
      messageError(type,msg,...args) {
        console.log(type,msg,...args);
         this.$message.error(msg);
      },
       // 显示确认操作的回调
      messageConfirm(type,msg,...args) {
        console.log(type,msg,...args);
        return new Promise((resolve,reject)=> {
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(true);
          }).catch(() => {
              reject()
          });
        })
      },
    }
  }
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/mk-editor/Editor.vue